angular
  .module('surfsightApp.controllers')
  .controller('OrganizationUserAddController', [
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    'dataFromCaller',
    'edgeGroupFactoryV2',
    function (
      $scope,
      $timeout,
      $interval,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      dataFromCaller,
      edgeGroupFactoryV2
    ) {
      const $translate = $filter('translate')
      $scope.isInternalUser = true
      $scope.newUser = {}
      $scope.newUser.organizationId = parseInt(dataFromCaller.organizationId)
      $scope.newUser.organizationIds = []
      $scope.newUser.role = 'user'
      $scope.newUser.super_admin = false

      $scope.newUser.permission_role = ''
      $scope.newUser.everything = false
      $scope.newUser.organizationAccessEdgeGroupIds = []

      $scope.organizations = dataFromCaller.organizations
      $scope.organizationId = dataFromCaller.organizationId

      $scope.selected_tab = 0
      $scope.Title = 'addMember'
      $scope.icon = 'person_add'

      $scope.formSubmit = false
      $scope.selectPermissionsTab = function (id) {
        $scope.formSubmit = true
        if (!$scope.newUser.email) {
          $scope.formSubmit = false
          $scope.showMessageToast('Please enter email')
          return false
        }
        if (!$scope.newUser.password) {
          $scope.formSubmit = false
          $scope.showMessageToast('Please enter password')
          return false
        }
        if ($scope.formSubmit) {
          $scope.Title = ''
          if (id == 0) {
            $scope.Title = 'addMember'
            $scope.selected_tab = id
            $scope.icon = 'person_add'
          } else if (id == 1) {
            $scope.Title = 'permissionsAndAccess'
            $scope.selected_tab = id
            $scope.icon = 'security'
          }
        }
      }

      $scope.getUserAccessPermissions = function () {
        var request_json = {
          method: 'GET',
          url:
            USER_BASEURL +
            '/userPermissions/' +
            $scope.UserPermissions.user_id +
            '/' +
            $scope.organizationId,
          data: $scope.UserPermissions
        }
        $http(request_json).then(
          function (response) {
            if (response.data.status.code == 0) {
              $scope.UserPermissions.organizationAccessEdgeGroupIds =
                response.data.user_permissions.organizationAccessEdgeGroupIds
              $scope.UserPermissions.everything =
                response.data.user_permissions.everything
              $scope.UserPermissions.role = response.data.user_permissions.role
            }
          },
          function (response) {
            if (response && response.data) {
              if (response.data.statusCode == 401) {
                $state.go('home.login')
              }
            } else {
              alert('Error occurred.')
            }
          }
        )
      }

      $scope.load_organizationsEdgeGroups = function () {
        $scope.organizationEdgeGroups = []
        $scope.loading = true
        edgeGroupFactoryV2.getGroups($scope.organizationId).then(
          function (response) {
            if (response.data && response.data.data) {
              $scope.organizationEdgeGroups = response.data.data
            }
            $scope.loading = false
          },
          function () {
            alert('Error Occurred')
            $scope.loading = false
          }
        )
      }
      $scope.load_organizationsEdgeGroups()

      $scope.organizationsIDs = []

      $scope.selectAll = function () {
        $scope.organizationsIDs = [-1]

        if ($scope.newUser.organizationAccessEdgeGroupIds.indexOf(-2) == -1) {
          $scope.organizationEdgeGroups.forEach(function (edgeGroup) {
            $scope.organizationsIDs.push(edgeGroup.id)
          })
          $scope.newUser.organizationAccessEdgeGroupIds =
            $scope.organizationsIDs
          $scope.newUser.everything = true
        } else {
          $scope.newUser.organizationAccessEdgeGroupIds = [-2]
        }
      }
      $scope.deSelectEverything = function () {
        var index = $scope.newUser.organizationAccessEdgeGroupIds.indexOf(-2)
        if (index > -1) {
          $scope.newUser.organizationAccessEdgeGroupIds.splice(index, 1)
        } else {
        }
      }
      $scope.addUser = function () {
        $scope.formSubmit = true
        if (!$scope.newUser.permission_role) {
          $scope.formSubmit = false
          $scope.showMessageToast('Please select user type')
          return false
        }
        if ($scope.newUser.organizationAccessEdgeGroupIds.length == 0) {
          $scope.formSubmit = false
          $scope.showMessageToast('Please select edge groups')
          return false
        }
        if ($scope.formSubmit) {
          var request_json = {
            method: 'POST',
            url: USER_BASEURL + '/user',
            data: $scope.newUser
          }
          $http(request_json).then(
            function (response) {
              if (response.data.status.code == 0) {
                $mdDialog.hide(response)
              } else {
                $scope.showMessageToast($translate(response.data.status.error))
              }
            },
            function (response) {
              if (response && response.data) {
                if (response.data.statusCode == 401) {
                  $state.go('home.login')
                }
                if (response.data.status && response.data.status.code === 1) {
                  $scope.showMessageToast(
                    $translate(response.data.status.error)
                  )
                }
              } else {
                alert('Error occurred.')
              }
            }
          )
        }
      }
      $scope.addExternalUser = () => {
        const requestJson = {
          method: 'POST',
          url: `${V2_BASEURL}/organizations/${$localStorage.currentUserOrganization.id}/external-users`,
          data: {
            email: $scope.newUser.email
          }
        }
        $http(requestJson).then(
          response => {
            $mdDialog.hide(response)
          },
          error => {
            if (error.data && error.data.message) {
              $scope.showMessageToast(error.data.message)
            } else {
              alert('Error occurred.')
            }
          }
        )
      }

      $scope.cancel = function () {
        $mdDialog.cancel()
      }

      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action('OK')
          .actionKey('F1')
          .position('bottom')
          .hideDelay(5000)
          .parent('#add-user-container')

        $mdToast
          .show(toast)
          .then(function (response) {})
          .catch(() => {})
      }
      $scope.closeSelectBox = function () {
        angular.element('md-backdrop').trigger('click')
      }
    }
  ])
